import createClient, { type ClientOptions } from "openapi-fetch";
import type { paths } from "./schema.d.ts";

export type { components, paths } from "./schema.d.ts";

export const createDriveClient = (options: ClientOptions) =>
  createClient<paths>({
    ...options,
    headers: { "X-Drive-Client": "1", ...options.headers },
  });

export type DriveClient = ReturnType<typeof createDriveClient>;
